import { jsx as _jsx } from "react/jsx-runtime";

function SvgHide() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.707 2.293a1 1 0 00-1.414 1.414L5.685 6.1a15.24 15.24 0 00-2.912 2.573 10.675 10.675 0 00-1.244 1.718C1.253 10.881 1 11.463 1 12c0 .399.138.803.292 1.144.165.363.395.755.673 1.154.557.8 1.347 1.69 2.31 2.521C6.188 18.471 8.912 20 12 20c2.172 0 4.162-.757 5.811-1.774l2.482 2.481a1 1 0 001.414-1.414l-17-17zm11.644 14.472l-1.737-1.737a4 4 0 01-5.642-5.642L7.13 7.544a13.205 13.205 0 00-2.85 2.443 8.7 8.7 0 00-1.008 1.386c-.223.396-.265.596-.271.624v.005c.005.023.026.124.113.317.102.224.264.509.492.836.456.654 1.13 1.42 1.976 2.15C7.29 16.78 9.565 18 12 18c1.547 0 3.032-.492 4.351-1.235zm-5.957-5.957a2 2 0 002.798 2.798l-2.798-2.798zM12 6c-.539 0-1.07.06-1.59.169A1 1 0 1110 4.212 9.714 9.714 0 0112 4c3.088 0 5.812 1.53 7.725 3.18.963.833 1.753 1.722 2.31 2.522.278.4.508.79.673 1.154.154.34.292.745.292 1.144 0 .582-.298 1.225-.622 1.769a11.648 11.648 0 01-1.47 1.913 1 1 0 11-1.463-1.364 9.675 9.675 0 001.215-1.574 3.74 3.74 0 00.283-.56c.04-.108.052-.167.056-.185-.005-.024-.026-.125-.113-.318a5.48 5.48 0 00-.492-.836c-.456-.654-1.13-1.42-1.976-2.15C16.71 7.22 14.434 6 12 6z"
    }, void 0)
  }), void 0);
}

export default SvgHide;